import React, { useEffect, useState } from 'react'
import { collection, getCountFromServer, query } from 'firebase/firestore';
import { useAuth } from '../../../../context/AuthContext';
import { db } from '../../../../firebase';


const TotalBookedUnitCount = ({ propID }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [totalCount, setTotalCount] = useState(0);

  async function getTotalBookedUnitCount(propID) {
    const q = query(collection(db, "Businesses", bid, "Properties", propID, "BookedUnits"));
    const snapshot = await getCountFromServer(q);
    setTotalCount(snapshot.data().count);
  }

  useEffect(() => {
    getTotalBookedUnitCount(propID);
  }, [])

  return `${totalCount}`;
}

export default TotalBookedUnitCount;